export { default } from './CatalogSpareParts';
